import React, { useRef } from "react";
import styled from "styled-components";

import { Tooltip } from "components/shared/Tooltip/Tooltip";
import { headlineText } from "./studentReportTable";
import { useIsTruncated } from "./useIsTruncated";

// A Math or Collaboration Headline: three lines, then an ellipsis. Only a
// headline the clamp actually cut shows its full text in a tooltip.

export const HeadlineCell = ({ text, onOpen }) => {
  const clampRef = useRef(null);
  const shown = headlineText(text);
  const truncated = useIsTruncated(clampRef, [shown]);

  return (
    // The full text is already in the cell, so the bubble stays silent to a
    // screen reader rather than reading it a second time.
    <Tooltip
      tip={truncated ? shown : null}
      placement="bottom"
      align="start"
      dismissOnEscape
      hiddenFromScreenReaders
    >
      <Clamp
        ref={clampRef}
        data-testid="headline"
        tabIndex={truncated ? 0 : undefined}
        onKeyDown={(event) => {
          if (truncated && event.key === "Enter") onOpen();
        }}
      >
        {shown}
      </Clamp>
    </Tooltip>
  );
};

const Clamp = styled.span`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
